import { Link } from "react-router-dom";
import { businessUrl } from "@/lib/businessUrl";

// Renders <a> for external (subdomain landing) or react-router <Link> for internal.
// All other props are forwarded to the underlying element.
export default function BusinessLink({ business, children, ...rest }) {
  const { external, url } = businessUrl(business);
  if (external) {
    return (
      <a href={url} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <Link to={url} {...rest}>
      {children}
    </Link>
  );
}
